import { _js } from '@ifixit/localize';
import { WikiTextEditor } from 'Shared/wiki_text_editor';
import { StatusNotice } from 'Shared/status_notice';
import { Utils } from 'Shared/utils';
import { Auth } from 'Shared/auth';
import { StatusFormManager } from 'Shared/form_manager';

onDomReady(() => {
   /**
    * Initialize the size of each input, making the source and translation
    * match up.
    */
   $$('.formField textarea').each(el => {
      let originalHeight = el.getScrollSize().y;
      // 2px over the scroll height makes nice padding for the text.
      let newHeight = Math.min(originalHeight + 2, 400);

      // The translation inputs have links to their source elements.
      // We can use that to make both boxes the same height.
      let sourceid = el.get('data-translate-source');
      if (sourceid) {
         let sourceEl = $(sourceid);
         let sourceHeight = sourceEl.getScrollSize().y;
         // Use the height from the bigger of the two elements, but keep it
         // under 400 px.
         newHeight = Math.min(400, Math.max(sourceHeight + 2, newHeight));
         sourceEl.setStyle('height', newHeight + 'px');
      }

      el.setStyle('height', newHeight + 'px');
   });

   new IntroTranslate();
});

export { IntroTranslate };
window.IntroTranslate = IntroTranslate;
function IntroTranslate() {
   let introForm = $('guideIntroForm'),
      saved = false,
      save = $$('.js-save'),
      cancel = document.querySelector('.js-cancel'),
      // Set up "form modified" behavior.
      formWatchInputs = $('formInputs'),
      introManager = new StatusFormManager(introForm, {
         statusChanged: statusChanged,
      }),
      fields = $$('[data-translate-field]').map(field => new TranslatableField(field));

   fields.each(field => {
      let element = field.element;
      if (field.needsTranslating()) {
         introManager.setValidator(element, () => {
            if (!field.value() && !element.disabled) {
               return introManager.requiredError();
            }
         });
      } else {
         statusChanged(element, 'ok');
      }
   });

   setupIntroToolbar();
   setupCopyTextButtons();

   introManager.addEvent('modifiedChanged', () => {
      formWatchInputs.addClass('unsaved');
   });

   // Validate the form when the user clicks Save.
   save.addEvent('click', ev => {
      ev.stop();
      introManager.validate(introManager.submit);
   });

   introManager.addSubmitHandler(() => {
      Auth.required({
         onAuthorize: saveGuide,
      });
   });

   // If the "Cancel" button is present, pressing it simply reloads the page.
   cancel?.addEvent('click', ev => {
      window.location.reload();
   });

   Utils.UnsavedChanges.addHandler(() => {
      if (!saved && formWatchInputs.hasClass('unsaved')) {
         return _js('You have unsaved changes. Your changes will be lost if you continue.');
      }
   });

   // Adjust the height of the new translation form to match the height of the original
   // guide form so the inputs match up.
   $$('.js-translation-diff').each(el => {
      let diffHeight = el.getComputedSize({ styles: ['margin', 'border', 'padding'] }).totalHeight;
      let field = el.get('data-field');

      if ($(field)) {
         $(field).setStyle('padding-bottom', diffHeight);
      }
   });

   function saveGuide() {
      save.disabled = true;
      saved = true;

      let guideValues = getFormValues();

      let method = 'PATCH';
      let path =
         'guides/' +
         App.guideApi.guideid +
         '/' +
         App.guideApi.langid +
         '?revisionid=' +
         App.guideApi.revisionid;

      new Request.API_2_0(path, {
         method: method,
         statusPanelMessage: _js('Saving...'),
         onSuccess: function (response) {
            window.location.reload();
         },
         onFailure: function (xhr, message) {
            save.disabled = false;
            saved = false;
         },
      }).send(guideValues);
   }

   function setupCopyTextButtons() {
      $$('.copyText').addEvent('click', function () {
         let field = this.get('data-translate-to');
         let toInput = $$('[data-translate-field="' + field + '"]');

         let fromInput = $(toInput.get('data-translate-source')[0]);

         statusChanged(toInput, 'ok');
         toInput.set('value', fromInput.get('value'));
      });
   }

   function getFormValues() {
      let output = {};
      fields.each(field => {
         output[field.apiName()] = field.value();
      });
      return output;
   }

   /**
    * This event is triggered if a form field's status changes.
    */
   function statusChanged(el, newStatus) {
      let statuses = {
         focused: 'fa-circle',
         error: 'fa-adjust',
         ok: 'fa-check-circle',
      };
      // Get status icon associated with this input.
      let statusEl = el.getParent().getElement('.js-status');

      Object.each(statuses, (icon, status) => {
         statusEl.toggleClass(icon, status === newStatus);
      });
   }

   function setupIntroToolbar() {
      // Set up the toolbar on the introduction box.
      let items = ['heading', 'bold', 'italic', 'ul', 'ol', 'link', 'video'];

      ['introIntroduction', 'editConclusionTextBox'].forEach(id => {
         if (!$(id)) {
            return;
         }

         new WikiTextEditor(id, null, {
            toolbarItems: items,
            className: 'wikiTextEditorToolbar noIcon',
            helpLink: window.guide_constants.GuideURI('TAG_FORMATTING_HELP'),
            helpText: _js('Formatting help'),
            defaultOpenInNewTab: true,
         });
      });
   }

   function TranslatableField(field) {
      this.element = field;

      this.needsTranslating = function () {
         // If the server has told us which fields to translate, use that.
         if (App.translatedFields) {
            return App.translatedFields.guideText[this.fieldName()] !== undefined;
         } else {
            // If there is an *original* field, this needs to be translated only
            // if that field has a value
            let sourceid = field.get('data-translate-source');
            return sourceid ? $(sourceid).value && !this.value() : true;
         }
      };

      this.apiName = function () {
         return field.get('data-translate-api') || this.fieldName();
      };

      this.fieldName = function () {
         return field.get('data-translate-field');
      };

      this.originalField = function () {
         let originalId = field.get('data-translate-original');
         if (originalId) {
            return $(originalId).value.trim();
         }
      };

      this.value = function () {
         return field.value.trim();
      };
   }
}
